<template>
  <div class="tkEdit full-height linear-main3">
    <ld-header
      transparent
      white
    >
      填写订单
    </ld-header>

    <div class="tkEditwrapper">
      <mescroll-vue
        ref="mescroll"
        :down="down"
      >
        <div class="box">
          <travel-tips :city-id="tkSearchInfo.arrport.cityId" />

          <!-- 行程 -->
          <div
            v-for="(info, index1) in flights"
            :key="index1"
            class="bg-white borderRadius overflow"
            @click.stop="showPlanes = true"
          >
            <van-cell
              :border="false"
              is-link
            >
              <div>
                <van-tag
                  class="tag-green"
                  round
                >
                  <span v-show="index1 == 0 && flights.length > 1">第1程</span>
                  <span v-show="index1 == 0 && flights.length == 1">{{ $t('C101', '单程') }}</span>
                  <span v-show="index1 == 1">第2程</span>
                </van-tag>
                <span class="font14 font">
                  {{ info.departDate }} {{ info.departDate | week }}&nbsp;{{
                    info.departTime
                  }}&nbsp;{{ info.cabin.cabinName }}
                </span>

                <span v-show="showProductTypeTips">
                  <van-tag
                    v-if="'' != showFirstProductTypeColor && (info.flightMinPrice == info.price.minPrice)"
                    :color="showFirstProductTypeColor"
                  >
                    {{ showFirstProductTypeText }}
                  </van-tag>
                  <van-tag
                    v-else
                    :color="info.price.productType | productTypeColor"
                  >
                    {{ info.price.productType | productType }}
                  </van-tag>
                </span>

                <div class="deep-gray font12">
                  {{ info.departAirportName }}&nbsp;{{ info.departTerminal }} - {{
                    info.arriveAirportName
                  }}&nbsp;{{ info.arriveTerminal }}
                </div>
                <div
                  v-show="info.sharFlightNo"
                  class="gray font12"
                >
                  实际乘坐：{{ info.sharFlightNo }}请按实际乘坐航班办理值机。
                </div>
              </div>
              <div class="main-color font12">
                <span @click.stop="toggle('rule', info)">{{ $t('F010', '退改签规则') }}</span>
              </div>
            </van-cell>
          </div>

          <!--出行人 -->
          <traver
            :person-list="tkSearchInfo.ccsqd.personList"
            :title="$t('C001', '乘机人')"
            :traveler-list="travelerList"
            class="borderRadius overflow"
            element=".tkEdit"
            @selected="initPrice"
          />
          <!--          @se="b"-->
          <!-- 保险  -->
          <insurance
            ref="insurance"
            :cxrlength="travelerList.length"
            class="borderRadius overflow"
            element=".tkEdit"
            @selected="checkBxList"
          />
          <!-- 服务费 -->
          <van-cell
            v-if="!isYlslh5"
            :title="$t('E001', '服务费')"
            class="borderRadius overflow"
          >
            <div>
              <span class="font16 red"><small>&yen;</small> {{ serviceFee }}</span>*{{
                travelerList.length
              }}人
            </div>
          </van-cell>
          <!-- 差旅信息 -->
          <travel-info
            v-show="tkSearchInfo.queryStr.tripType == 1"
            ref="travelinfo"
            class="borderRadius overflow"
            element=".tkEdit"
            @selected="getTavelInfo"
          />

          <!-- 联系信息 -->
          <div class="borderRadius overflow">
            <van-field
              :label="$t('D022', '联系信息')"
              :readonly="true"
              is-link
              @click="$refs['linker'].toggle()"
            >
              <div slot="input">
                {{ linker.linkMan }} ({{ linker.linkTel || linker.linkMobile }})

                <div
                  v-if="linker.linkEmail"
                  class="font12 gray"
                >
                  {{ $t('D020', '邮箱') }} ({{ linker.linkEmail }})
                </div>
              </div>
            </van-field>
          </div>

          <!-- 编辑联系人 -->
          <ld-edit-linker
            ref="linker"
            :data="linker"
            @selected="getLinker"
          />

          <div
            v-if="false"
            v-show="this.sl"
            class="font12 gray pad-b-20"
          >
            点击“提交订单”表示已阅读锂电池规定、禁止危险品乘机说明、{{ loginConfig.pageName }}购票须知。
          </div>

          <!-- 协议 -->
          <div
            v-show="this.ysf"
            class="agreementBox flex-h background-white pad10 padt10 FF"
          >
            <div class="checkClass">
              <van-checkbox
                v-model="agrChecked"
                icon-size="16px"
                shape="square"
              />
            </div>
            <div class="agreementBox-main flex-1 ft-12 padl10 ">
              <span>订单包括机票、附加选购产品、机建燃油费、税费。点击下一步表示本人已阅读并同意</span>
              <span
                v-for="(item, index) in agreeArr"
                :key="index"
                class="colorBlue"
                @click="clickAgree(item, index)"
              >
                {{ item.name }}
                <i v-if="index != agreeArr.length - 1">、</i>
              </span>
              <br>
              <span class="colorCustomized">本平台为信息服务平台，具体机票产品及服务（如出票、退改、配送、保险等），由对应航空公司或票务代理机构为您提供</span>
            </div>
          </div>
        </div>
      </mescroll-vue>
      <!-- 协议文本弹出 -->
      <van-popup
        v-model="agreeShow"
        :style="{ height: '94%' }"
        class="flex-v agreeCom"
        close-icon="close"
        close-icon-position="top-right"
        closeable
        get-container="body"
        position="bottom"
        safe-area-inset-bottom
      >
        <agreementTextCom :agree-tit="agreeTit" />
      </van-popup>
    </div>
    <!-- 底部导航 -->
    <ld-tabbar
      ref="tabbar"
      :price-list="priceList"
    >
      <van-row
        align="center"
        class="bg-white full-width shadow"
        justify="space-between"
        type="flex"
      >
        <van-col span="1" />
        <van-col span="7">
          <span class="font12 money-color">&yen;</span><span class="font22 money-color">{{ totalPrice
          }}</span>
          <span class="font10 gray">{{ $t('E017', '共') }}{{ travelerList.length }}人</span>
          <br>
          <span>多程总价</span>
        </van-col>

        <van-col span="8">
          <div
            class="font12 text-left"
            @click="toggle('tabbar')"
          >
            <span>{{ $t('E006', '明细') }}</span>
            <van-icon
              class="vertical-middle"
              name="arrow-up"
              size="14"
            />
          </div>
        </van-col>
        <van-col
          class="pad-r-8"
          span="8"
        >
          <ld-button
            :loading="false"
            main
            size="md"
            @click.native="book"
          >
            {{ $t('F560', '提交订单') }}
          </ld-button>
        </van-col>
      </van-row>
    </ld-tabbar>


    <!-- 退改规则 -->
    <refund-change-rule
      ref="rule"
      :obj="changeRule"
      cplx="10901"
    />


    <!-- 行程展示 -->
    <van-popup
      v-model="showPlanes"
      :close-on-popstate="true"
      class="popup-width"
    >
      <voyage
        :flights="flights"
        :show-cabin="true"
      />
    </van-popup>


    <!-- 预留改签提示 -->
    <van-dialog
      v-model="showReserved"
      :confirm-button-text="$t('B012', '继续预订')"
      :title="$t('C474', '提示')"
      show-cancel-button
      @cancel="showReserved = false"
      @confirm="sendAjax"
    >
      <van-cell>
        <div
          v-for="(info, index2) in reservedData"
          :key="index2"
          class="text-indent"
        >
          {{ $t('Q510', '乘客') }} <span class="orange">{{ info.psgName }}</span>
          <van-tag
            v-show="info.fsEmpId"
            type="warning"
          >
            {{ $t('attach', '附') }}
          </van-tag>
          {{ $t('There', '存在预留改签的机票； 行程：') }}<span>{{ info.voyageZh }}</span>， {{ info.departTime }}， {{
            info.flightNo
          }}，可联系客服进行改签!
        </div>
      </van-cell>
    </van-dialog>
  </div>
</template>

<script>
import {Cell, Tag, Popup, Field, Checkbox, CheckboxGroup, Toast, Dialog} from 'vant'
import { mapGetters } from 'vuex'
import ldEditLinker from 'Components/ldEditLinker'
import MescrollVue from 'mescroll.js/mescroll.vue'
import ldHeader from 'Common/ldHeader'
import travelInfo from 'Components/travelInfo'
import insurance from 'Components/tk/Multi-passSplitInsurance/index'
import refundChangeRule from 'Components/refundChangeRule'
import voyage from 'Components/tk/voyage'
import traver from 'Components/tk/Multireach/index'
import ldTabbar from 'Components/ldTabbar/ldTabbar'
import ldButton from 'Common/ldButton'
import { getName, getIdType, getIdNumber } from 'Utils/publicFun'
import orderMixin from '@/business/views/Home/allorder/components/orderMixin'
import travelTips from 'Components/travelTips'
import { getSysType } from 'CommonUtils/plus.js'
import { validators } from 'Utils/valid'
import defaultMixin from '@/business/mixins/default'
import agreementTextCom from '@/business/components/agreement/agreementText.vue'
import {localget, localset, localremove} from 'Utils/storage'


export default {
  name: 'TkEdit',
  mixins: [orderMixin, defaultMixin],
  components: {

    ldHeader,
    travelInfo,
    [Cell.name]: Cell,
    [Tag.name]: Tag,
    [Popup.name]: Popup,
    [Field.name]: Field,
    [Checkbox.name]: Checkbox,
    [CheckboxGroup.name]: CheckboxGroup,
    insurance,
    refundChangeRule,
    voyage,
    traver,
    ldTabbar,
    ldButton,
    ldEditLinker,
    MescrollVue,
    travelTips,
    agreementTextCom,
    localget,
    localset,
    localremove
  },
  data () {
    return {
      ctsf:'',
      crsf:'',
      ertbx:'',
      crbx:'',
      list: [],
      Price: 0,//价格.
      length: 0,
      selectedCoupon: -1,
      ticPirce: 0, //机票价格
      coupon: {}, // 优惠劵对象
      couponShow: false,
      check:[],
      dissa:false,
      tre:true,
      yc:true,
      ysf: false,
      sl: false,
      show: false,
      agrChecked: false, //是否同意协议
      agreeShow: false, //协议是否弹出
      agreeTit: '', //协议的tit
      down: { use: false },
      showPlanes: false,
      showPrice: false,
      showReserved: false,
      priceList: [],
      changeRule: {},
      travelInfo: {},
      linker: {
        linkMan: '',
        linkTel: '',
        linkEmail: ''
      },//联系人信息
      bxPrice: null,
      reservedData: [],
      p_11601001: 0,
      isCivilError: false,//判断是否有验证不通过的GP 身份信息
      // showCabin:false
      showProductTypeTips: true,
      showFirstProductTypeTips: false,
      showFirstProductTypeColor: '',
      showFirstProductTypeText: ''
    }
  },
  computed: {
    ...mapGetters({
      tkSearchInfo: 'tk/tkSearchInfo',
      travelerList: 'tk/travelerList',
      tripType: 'tripType',
      pageCtrl: 'serviceCtrl', //页面控制信息
      userInfo: 'userInfo',
      sysType: 'sysType',
      loginConfig: 'loginConfig',
    }),
    agreeArr () {
      //协议文本tit
      let arr = []
      if (this.isMU) {
        //如果OPL12东航、上航
        arr = [
          {
            name: '《购票须知》',
            // link: "https://activity.ceair.com/UI/25792TravelGuide/app/pas-ticket-notes.html",
            link: 'https://activity.ceair.com/UI/27845/app/notice.html',
          },
          {
            name: '《旅客须知》',
            link: 'https://activity.ceair.com/UI/25792TravelGuide/app/passengerNotes.html',
          },
          {
            name: '《特殊旅客须知》',
            link: 'https://activity.ceair.com/UI/25792TravelGuide/app/spePaserServe.html',
          },
          {
            name: '《托运危险品说明》',
            link: 'https://activity.ceair.com/UI/25792TravelGuide/app/baggage-restrictions.html',
          },
          {
            name: '《东上航国内国际运输条件》',
            link: 'https://activity.ceair.com/UI/25792TravelGuide/app/second.html?num=48',
          },
        ]
      } else if (this.isCZ) {
        //南航OPL11
        arr = [
          {
            name: '《用户信息安全须知》',
            link: '',
          },
          {
            name: '《锂电池安全运输提示》',
            link: '',
          },
          {
            name: '《旅客、行李国内运输总条件》',
            link: '',
          },
        ]
      } else if (this.isMF) {
        //厦航OPL13
        arr = [
          {
            name: '《隐私通知提示》',
            link: '',
          },
          {
            name: '《用户信息安全须知》',
            link: '',
          },
          {
            name: '《危险品运输规定》',
            link: '',
          },
          {
            name: '《国内运输总条件》',
            link: '',
          },
          {
            name: '《关于新冠肺炎疫情期间乘机出行注意事项的通知》',
            link: '',
          },
        ]
      } else {
        arr = [
          {
            name: '《机票预订须知》',
            link: '',
          },
          {
            name: '《用户信息安全须知》',
            link: '',
          },
          {
            name: '《锂电池及危险品须知》',
            link: '',
          },
        ]
      }
      if (this.insuranceStrPrice && this.exProArr.length) {
        //如果包含保险
        let arrAy = []
        this.exProArr.forEach((item) => {
          if (item.productId == 25) {
            //保险
            let proObj = {
              name:
                item.productName.indexOf('意外险') != -1
                  ? '《' + item.productName + item.price + '元》'
                  : '《' + item.productName + '》',
              link: '',
            }
            arrAy.push(proObj)
          }
        })
        arr = [...arr, ...arrAy]
      }
      return arr
    },

    serviceFee () {//服务费
      let see = this.tkSearchInfo.flights[0].price.serviceFee - 0 + (this.tkSearchInfo.flights[1] ? this.tkSearchInfo.flights[1].price.serviceFee : 0)
      return see
    },
    airportFee () {//基建
      let fee = this.tkSearchInfo.flights[0].airportFee - 0 + (this.tkSearchInfo.flights[1] ? this.tkSearchInfo.flights[1].airportFee : 0)
      return fee
    },
    taxcr () {//税费
      let taxcr = this.crsf
      return taxcr
    },
    cts () {//税费
      let cts =  this.ctsf
      return cts
    },
    totalPrice () {//总票价
      if (this.priceList[0]) {
        const adtPrice = this.getPrice(this.priceList, 'adt')
        const chdPrice = this.getPrice(this.priceList, 'chd')
        const Price = this.Price
        return adtPrice * this.tkSearchInfo.queryStr.aduNum + chdPrice * this.tkSearchInfo.queryStr.chdNum - Price
      }
      // if (this.priceList[0]) {
      // 	return this.priceList[0].price * this.tkSearchInfo.queryStr.aduNum +
      // 		this.priceList[1].price * this.tkSearchInfo.queryStr.chdNum +
      // 		this.priceList[2].price * this.tkSearchInfo.queryStr.infNum
      // }
      return 0
    },
    flights () {
      return this.tkSearchInfo.flights
    },
  },
  mounted () {
    if(this.$route.query.i == 2) {
      var file = JSON.parse(sessionStorage.getItem('flights'))
      var priceId = JSON.parse(sessionStorage.getItem('priceId'))
      console.log(this)
      for (var i = 0; i <this.travelerList.length; i++) {
        let birthdays = new Date(this.travelerList[i].born.replace(/-/g, '/'))
        let d = new Date()
        let age =
          d.getFullYear() -
          birthdays.getFullYear() -
          (d.getMonth() < birthdays.getMonth() ||
          (d.getMonth() == birthdays.getMonth() &&
            d.getDate() < birthdays.getDate()) ? 1 : 0)
        // 证件类型的判断
        for (let i = 0; i < this.cache.length;i++){
          console.log(this.cache[i])
        }
        var _obj =[
          {
            'cacheId':this.cache[0].cacheId,
            'priceId': this.cache[0].priceId,
            'flightNo': this.cache[0].flightNo,
            'cardNo': this.travelerList[i].idNumber,
            'cardType': 'NI',
            'age': age
          },
          {
            'cacheId':this.cache[1].cacheId,
            'priceId':this.cache[1].priceId,
            'flightNo':this.cache[1].flightNo,
            'cardNo': this.travelerList[i].idNumber,
            'cardType': 'NI',
            'age': age
          }
        ]
        this.$api['tkQuery/checkXyhAge']({
          datas:_obj
        }).then(res => {
          if(res.data.checkResult == false){
            this.tre = false
            setTimeout(() =>{
              Toast.loading({
                duration: 3000, // 持续展示 toast
                forbidClick: true,
                message: res.data.resultMsg,
              })
              this.dissa = true
            },1000)
            this.dissa = true
            setTimeout(()=>{
              Dialog({ message: res.data.resultMsg })
            },350)
          }else{
            if(res.data.resultMsg == 'SUCCESS'){

            }else{
              Dialog.confirm({
                title: '温馨提示!',
                message: res.data.resultMsg ,
                confirmButtonText:'继续',
                cancelButtonText:'返回',
              })
                .then(() => {
                  this.$router.push('/tk/tkEditlc?text=我是阿格斯之盾&i=2')
                })
                .catch(() => {
                  // on cancel
                  this.$router.push('/tk/tkListlc?text=我是阿格斯之盾')
                })
            }

          }
        })
      }
    }
    /*
    * 差旅信息 信息回显
    * this.tkSearchInfo.ccsqd 出差单详情信息
    * this.tkSearchInfo.violate 违背详情信息
    * this.$refs.travelinfo.getInfo方法 回显到页面
    */
    if (this.tripType == 1) {
      this.$refs.travelinfo.getInfo({ ...this.tkSearchInfo.violate, ...this.tkSearchInfo.ccsqd })
    }
  },
  created () {
    this.init()
    const data = JSON.parse(localStorage.getItem('userInfo'))
    if (data === null) {
      this.sl = true
      this.agrChecked = true
    } else {
      if (data.vipCorp.corpNo == 'YLCX') {
        this.ysf = true
        this.agrChecked = false
      } else {
        this.sl = true
        this.agrChecked = true

      }
    }
    if(this.linker.linkEmail ==''){
      this.yc = false
    }else{
      this.yc = true
    }

  },
  methods: {
    // 解决保险重复添加问题
    b(){
      this.$refs.insurance.bxList =[]
      console.log('555')
    },
    // 协议
    clickAgree (item) {
      if (item.link) {
        location.href = item.link
        return
      }
      this.agreeTit = item.name
      this.agreeShow = !this.agreeShow
    },
    // 获取单人总价
    getPrice (priceList, type) {
      if (!priceList || priceList.length < 1) {
        return 0
      }
      let p = 0,
        cn = 0,
        yq = 0,
        fw=0,
        yr=0,
        rt=0,
        bx=0
      priceList.forEach(item => {
        if (item.type === type + 'P') {
          p = item.price
        } else if (item.type === type + 'CN') {
          cn = item.price
        } else if (item.type === type + 'YQ') {
          yq = item.price
        }else if (item.type === type + 'FW'){
          fw = item.price
        }else if (item.type === type + 'YR'){
          yr = item.price
        }else if (item.type === type + 'RT'){
          rt = item.price
        }else if (item.type === type + 'BX'){
          bx = item.price
        }
      })
      return p + cn + yq + fw + yr+rt+bx//相加总金额
    },
    async init () {
      this.$api['common/queryVipParameter']({
        paramNo: '11601022'
      }).then(res => {
        let cache = res.data || {}
        this.showProductTypeTips = cache.value1 == 1 ? false : true
        this.showFirstProductTypeTips = cache.value2 == 1 ? true : false
        if (this.showFirstProductTypeTips) {
          this.$api['common/queryVipParameter']({
            paramNo: '11601024'
          }).then(resp => {
            let cacheProduct = resp.data || {}
            this.showFirstProductTypeText = cacheProduct.value2
            this.showFirstProductTypeColor = cacheProduct.value1
          })
        }
      })

      if (this.tkSearchInfo.queryStr.travelType == 2) {
        let arr = this.tkSearchInfo.queryStr.arriveAirport
        this.tkSearchInfo.queryStr.arriveAirport = this.tkSearchInfo.queryStr.departAirport
        this.tkSearchInfo.queryStr.departAirport = arr
        this.tkSearchInfo.queryStr.departDate = this.tkSearchInfo.queryStr.arriveDate;
        [this.tkSearchInfo.depport, this.tkSearchInfo.arrport] = [this.tkSearchInfo.arrport, this.tkSearchInfo.depport]
      }
      this.linker = {
        linkMan: this.userInfo.empInfo.empName,
        linkTel: this.userInfo.empInfo.phoneNumber,
        linkEmail: this.userInfo.empInfo.email
      }

      // 检查乘机人手机号码是否有重复   系统参数11601001控制是否检查
      let { data = {} } = await this.$api['common/getSysParameter']({
        paramNo: '11601001'
      })

      if (data.value1) this.p_11601001 = data.value1 || '0'

      // this.$api['common/queryParameter']({
      // 	paramNos:'11601019'
      // }).then(res => {
      // 	let cache = res.data || {}
      // 	this.showCabin=cache.value1
      // })

      this.initPrice()
    },
    initPrice () {
      this.initPsgNum()
      let arr = []
      let arr1 = []
      this.flights.map(res => {
        arr.push({
          cacheId: res.cacheId,
          priceId: res.price.priceId,
          rangeList: res.cabinKey, //舱位键
        })
        arr1.push({
          cacheId: res.cacheId,
          priceId: res.price.priceId,
          rangeList: res.cabinKey, //舱位键
          flightNo:res.flightNo
        })
      })
      this.cache =arr1
      sessionStorage.setItem('cache',JSON.stringify(arr1))

      this.$api['tkQuery/getAddConPrice']({//动态获取票价
        rangeBeanList: arr,
        tripType: this.tripType
      }).then(res => {
        this.cache = res.cache || {}
        console.log(this.cache)
        let cache = res.data || {}
        this.crsf=cache.aduTax
        this.ctsf=cache.chdTax
        this.ticPirce = cache.fcny
        sessionStorage.setItem('cache1', JSON.stringify(cache))
        for (let i = 0; i < this.travelerList.length; i++) {
          if(this.travelerList[i].psgType ==1){
            this.crbx = this.bxPrice
          }else if(this.travelerList[i].psgType ==2){
            this.ertbx = this.bxPrice
          }else if(this.travelerList[i].psgType !=1){
            this.crbx = ''
          }else if(this.travelerList[i].psgType !=2){
            this.ertbx = ''
          }
        }
        var chengren = this.crbx+=this.crbx
        var ertong = this.ertbx+=this.ertbx
        // this.bxPrice = chengren
        // {name:'保险',price:this.details.bxPrice?this.details.bxPrice/cxr.length:0,amount:`/${this.checkBxList.length}份`,unit:''},
        this.priceList = [
          {
            type: 'spliter',
            name: '-------- ' + this.$t('C115', '成人') + ' --------',
            price: null,
            amount: null,
            unit: '',
            show: this.tkSearchInfo.queryStr.aduNum > 0,
            hideYen: this.tkSearchInfo.queryStr.aduNum > 0
          },
          {
            type: 'adtP',
            name: this.$t('成人'),
            price: cache.fcny+this.airportFee+this.taxcr+this.serviceFee+chengren,
            amount: this.tkSearchInfo.queryStr.aduNum,
            unit: '/' + this.$t('E113', '人'),
            show: this.tkSearchInfo.queryStr.aduNum > 0
          },
          {
            type: 'adtP',
            name: this.$t('C1150', '票面'),
            price: cache.fcny,
            // amount: this.tkSearchInfo.queryStr.aduNum,
            unit: '/' + this.$t('E113', '人'),
            show: this.tkSearchInfo.queryStr.aduNum > 0
          }, {
            type: 'adtCN',
            name: this.$t('E102', '机建')+'  ('+'共'+2+'程'+')',
            price: this.airportFee ,
            // amount: this.tkSearchInfo.queryStr.aduNum,
            unit: '/' + this.$t('E113', '人'),
            show: this.tkSearchInfo.queryStr.aduNum > 0
          },
          {
            type: 'adtYQ',
            name: this.$t('E103', '燃油税')+'  ('+'共'+2+'程'+')',
            price: this.taxcr,
            // amount: this.tkSearchInfo.queryStr.aduNum,
            unit: '/' + this.$t('E113', '人'),
            show: this.tkSearchInfo.queryStr.aduNum > 0
          },
          {
            type: 'adtFW',
            name: this.$t('E001', '服务费')+'  ('+'共'+2+'程'+')',
            price: this.serviceFee,
            // amount: this.tkSearchInfo.queryStr.aduNum,
            unit: '/' + this.$t('E113', '人'),
            show: this.tkSearchInfo.queryStr.aduNum > 0
          },
          {
            type: 'adtBX',
            name: this.$t('E505', '保险')+'  ('+'共'+2+'程'+')',
            price: chengren,
            // amount: `/ ${this.tkSearchInfo.queryStr.aduNum}份`,
            unit: '',
            show: this.crbx > 0 && this.tkSearchInfo.queryStr.aduNum > 0
          },
          {
            type: 'spliter',
            name: '-------- ' + this.$t('C116', '儿童') + ' --------',
            price: null,
            amount: null,
            unit: '',
            show: this.tkSearchInfo.queryStr.chdNum > 0,
            hideYen: true
          },
          {
            type: 'chdP',
            name: this.$t('C116', '儿童'),
            price: cache.chdFcny+this.cts+this.serviceFee+ertong,
            amount: this.tkSearchInfo.queryStr.chdNum,
            unit: this.$t('E113', '人'),
            show: this.tkSearchInfo.queryStr.chdNum > 0
          },
          {
            type: 'chdP',
            name: this.$t('票面'),
            price: cache.chdFcny,
            // amount: this.tkSearchInfo.queryStr.chdNum,
            unit: this.$t('E113', '人'),
            show: this.tkSearchInfo.queryStr.chdNum > 0
          },
          {
            type: 'chdCN',
            name: this.$t('E102', '机建')+'  ('+'共'+2+'程'+')',
            price: 0,
            // amount: this.tkSearchInfo.queryStr.chdNum,
            unit: '/' + this.$t('E113', '人'),
            show: this.tkSearchInfo.queryStr.chdNum > 0
          }, {
            type: 'chdRT',
            name: this.$t('E103', '燃油税')+'  ('+'共'+2+'程'+')',
            price:this.cts,
            // amount: this.tkSearchInfo.queryStr.chdNum,
            unit: '/' + this.$t('E113', '人'),
            show: this.tkSearchInfo.queryStr.chdNum > 0
          },
          {
            type: 'chdFW',
            name: this.$t('E001', '服务费')+'  ('+'共'+2+'程'+')',
            price: this.serviceFee,
            // amount: this.tkSearchInfo.queryStr.chdNum,
            unit: '/' + this.$t('E113', '人'),
            show: this.tkSearchInfo.queryStr.chdNum > 0
          },
          {
            type: 'chdBX',
            name: this.$t('E505', '保险')+'  ('+'共'+2+'程'+')',
            price:ertong,
            // amount: `/ ${this.tkSearchInfo.queryStr.chdNum}份`,
            unit: '',
            show: this.ertbx > 0 && this.tkSearchInfo.queryStr.chdNum > 0
          },
          // {
          // 	type: 'spliter',
          // 	name: '-------- ' + this.$t('婴儿') + ' --------',
          // 	price: null,
          // 	amount: null,
          // 	unit: '',
          // 	show: this.tkSearchInfo.queryStr.chdNum > 0,
          // 	hideYen: true
          // },
          // {
          // 	type: 'chdYR',
          // 	name: this.$t('C117', '婴儿'),
          // 	price: cache.infFcny + this.airportFee + this.tax + this.serviceFee + this.bxPrice,
          // 	amount: this.tkSearchInfo.queryStr.infNum,
          // 	unit: this.$t('E113', '人'),
          // 	show: this.tkSearchInfo.queryStr.infNum > 0
          // },
          // {
          //   type: 'chdCN',
          //   name: this.$t('E102', '机建'),
          //   price: 0,
          //   amount: this.tkSearchInfo.queryStr.chdNum,
          //   unit: '/' + this.$t('E113', '人'),
          //   show: this.tkSearchInfo.queryStr.chdNum > 0
          // },
          // {
          //   type: 'chdYQ',
          //   name: this.$t('E103', '燃油税'),
          //   price: 0,
          //   amount: this.tkSearchInfo.queryStr.chdNum,
          //   unit: '/' + this.$t('E113', '人'),
          //   show: this.tkSearchInfo.queryStr.chdNum > 0
          // }
        ]
        this.tkSearchInfo.priceList = this.priceList
      }).catch(res => {
        this.queryAgain(res.tips)
      })
    },
    initPsgNum () {
      this.tkSearchInfo.queryStr.aduNum = 0
      this.tkSearchInfo.queryStr.chdNum = 0
      this.tkSearchInfo.queryStr.infNum = 0
      this.travelerList.forEach(item => {
        if (item.psgType == 1 || !item.psgType) {
          this.tkSearchInfo.queryStr.aduNum += 1
        } else if (item.psgType == 2) {
          this.tkSearchInfo.queryStr.chdNum += 1
        } else if (item.psgType == 3) {
          this.tkSearchInfo.queryStr.infNum += 1
        }
      })
    },
    getTavelInfo (info) {// 获取差旅信息
      this.travelInfo = info
    },
    getDecimalLength(arg = '') {
      try {
        return arg.toString().split('.')[1].length
      } catch (e) {
        return 0
      }
    },
    getNum(arg = '') {
      return Number(arg.toString().replace('.', ''))
    },
    divisionCount(arg1, arg2) {
      let t1, t2
      t1 = this.getDecimalLength(arg1)
      t2 = this.getDecimalLength(arg2)
      if (t1 - t2 > 0) {
        return this.getNum(arg1) / this.getNum(arg2) / Math.pow(10, t1 - t2)
      } else {
        return (this.getNum(arg1) / this.getNum(arg2)) * Math.pow(10, t2 - t1)
      }
    },
    book() {//提交订单
      var cache_jg = JSON.parse(sessionStorage.getItem('cache1'))
      if (this.travelerList.length < 1) {
        this.$toast(this.$t('I001', '请选择出行人'))
        return
      }
      if (!this.agrChecked) {
        this.$toast('请认真阅读并同意航司相关协议')
        return
      }
      let psgList = this.travelerList.map((item, index) => {
        return {
          empId: item.conempId || item.empId,
          idType: getIdType(item),
          idno: getIdNumber(item),
          phoneNumber: item.phoneNumber,
          psgName: getName(item),
          psgType: item.psgType || '1',
          sex: item.sex,
          born: item.born,
          sn: index + 1,
        }
      })
      var st = psgList.filter(item => {
        return item.psgType == '2'
      })
      if (st.length == 0) {

      } else {
        if (cache_jg.chdFcny == '' || '') {
          Dialog.alert({
            title: '温馨提示!',
            message: '该行程不允许预订儿童!',
          }).then(() => {
          })
          return false
        }


      }

      let adultNum = psgList.filter(item => {
        return item.psgType == 1
      })
      let notAdultNum = psgList.filter(item => {
        return item.psgType != 1
      })
      if (adultNum.length == 0) {
        this.$toast('儿童或婴儿不能单独出行，请选择同行成人')
        return
      } else if (notAdultNum.length != 0) {
        let multipleNum = this.divisionCount(notAdultNum.length, adultNum.length)
        if (multipleNum > 2) {
          this.$toast('一名成人最多携带两名儿童或婴儿，请重新选择乘客')
          return
        }
      }

      psgList.some((item) => {
        if (!item.cardNo) {
          this.$toast('乘机人证件号码不能为空')
        }
      })
      if (psgList.some(item => !item.phoneNumber)) {
        this.$toast('乘机人手机号不能为空')
        return
      }
      if (psgList.some(item => !validators.telephone(item.phoneNumber).valid)) {
        this.$toast('请填写正确手机号码格式')
        return
      }

      if (this.p_11601001 == '0' && this.checkRepeatPhone(psgList)) {
        this.$toast('乘机人手机号不允许重复，请核对后重新提交')
        return
      }

      if (this.tkSearchInfo.violate && this.tkSearchInfo.violate.canBook === '0') {
        this.$toast('您选择的出行人违背差旅标准，不允许预订，请重新选择。')
        return
      }
      let bl = this.$refs.travelinfo.result()//判断差旅信息是否填写完整
      if (bl) {
        let num = 0
        let validateTimeOut = () => {
          localStorage.setItem('tkListFilter', JSON.stringify({
            activeV: 2,
            activeFilterNum: 1,
            activeTabArr: [],
          }))
          let element = this.flights[0], obj = {}
          if (element) {
            obj = {
              cacheId: element.cacheId,
              cabinKey: element.cabinKey
            }
            this.$api['tkQuery/validateTimeOut'](obj).then(res => {
              num += (res.errCode - 0)
              if (num == this.flights.length) {
                this.reserved()
              } else {
                validateTimeOut()
              }
            }).catch(res => {
              this.queryAgain(res.tips)
            })
          }
        }
        validateTimeOut()
      }
    },
    reserved () {// 预留票
      //是否有预留改签票
      // 改签预留
      if (!this.travelerList || this.travelerList.length == 0) return
      let arr = []
      this.travelerList.forEach(res => {
        let obj = {
          idNo: getIdNumber(res),
          psgName: getName(res),
          voyage: (this.tkSearchInfo.depport.threeCode || this.tkSearchInfo.depport.departAirport) +
            (this.tkSearchInfo.arrport.threeCode || this.tkSearchInfo.arrport.arriveAirport)
        }
        arr.push(obj)
        if (this.flights.length > 1) {
          obj.voyage = (this.tkSearchInfo.arrport.threeCode || this.tkSearchInfo.arrport.arriveAirport) +
            (this.tkSearchInfo.depport.threeCode || this.tkSearchInfo.depport.departAirport)
          arr.push(obj)
        }
      })
      var self = this
      this.$api['tkQuery/checkYlgqTkno']({
        psgName: arr
      }).then(res => {
        let cache = res.data || []
        if (cache.length > 0) {
          // 显示
          self.reservedData = cache
          self.showReserved = true
        } else {
          this.sendAjax()
        }
      }).catch(res => {
        // this.$toast(res.tips)
      })
    },
    // 下单
    sendAjax () {
      let bxcpList = this.$refs.insurance.getInsurance()
      let obj = {
        ccsqdId: this.travelInfo.ccsqdId,
        ccsqdNo: this.travelInfo.ccsqdNo,
        ccsqdRemark: this.travelInfo.ccsy || this.travelInfo.ccsqdRemark || '',
        costCenterCode: this.travelInfo.costCenterCode,
        costCenterId: this.travelInfo.costCenterId,
        costCenterName: this.travelInfo.costCenterName,
        subjectCode: this.travelInfo.subjectCode,//科目码
        projectCode: this.travelInfo.projectCode,
        projectId: this.travelInfo.projectId || this.travelInfo.id,
        projectName: this.travelInfo.projectName,
        empRank: this.tkSearchInfo.empRank,
        linkEmail: this.linker.linkEmail,
        linkMan: this.linker.linkMan,
        linkTel: this.linker.linkTel,
        orderFrom: getSysType(),//this.orderfrom,
        postCode: '', //邮编
        rangeType: 3,
        reciAddr: '', //收件地址
        reciPhone: '',
        reciPient: '', //收件人
        routeId: this.tkSearchInfo.voyage.routeId, //行程ID
        sendMode: 1, //公司统一配送
        supplierId: this.flights[0].price.supplierId, //供应商id
        travelNo: '', //出差申请单号
        travelStandard: this.tkSearchInfo.queryStr.empRank, //标准差标等级
        tripType: this.tkSearchInfo.queryStr.tripType, //因公因私
        psgList: this.travelerList.map((item, index) => {
          var obj = {
            // empId: item.conempId||item.personId||item.contactsId||item.empId,//顺序不能变
            /**
             * 只要是员工id 传过来就可以了
             * 不要传personId 也不要传常旅客id, 后台不支持
             */
            empId: item.conempId || item.empId,
            idType: getIdType(item),
            idno: getIdNumber(item),
            phoneNumber: item.phoneNumber,
            psgName: getName(item),
            psgType: item.psgType || '1',
            sex: item.sex,
            born: item.born,
            sn: index + 1,
            isCivil: item.isCivil,
            nation:item.nation,
            passportPeriod:item.passportPeriod,
          }
          if (this.pageCtrl.isCivil == 1) {
            if (this.tkSearchInfo.queryStr.showGpProduct) {
              Object.assign(obj, {
                civilCheck: item.civilCheck || '',
                civilBankId: item.civilBankId || '',
                civilBankName: item.civilBankName || '',
                unitAddress: item.unitAddress || '',
              })
              if (item.isCivilError) {
                this.isCivilError = true
              }
            }
          }
          return obj
        }),
        rangeList: this.flights.map((item,index) => {
          return {
            cacheId: item.cacheId,
            priceId: item.price.priceId,
            rangeList: item.cabinKey,
            reasonCode: this.travelInfo.reasonCode,
            reasonDesc: this.travelInfo.reasonDesc,
            logotype:index+1
          }
        }),
        bxcpList: bxcpList
      }
      console.log('obj',obj)
      if (this.tkSearchInfo.queryStr.showGpProduct) {
        let bool = false
        obj.psgList.forEach(item => {
          if (!item.isCivil) {
            bool = true
          }
        })
        if (bool) {
          this.$dialog.alert({
            title: '提示',
            message: '已开启公务员订票，请完整填写公务员购票信息！'
          })
          return
        }

        obj.psgList.forEach(item => {
          delete item.isCivil
        })

        if (this.isCivilError) {
          this.$dialog.confirm({
            title: '提示',
            message: '公务员身份验证不通过，可能导致出票失败，请确认是否继续下单？'
          }).then(() => {
            this.bookOrder(obj)
          }).catch(() => {

          })
        } else {
          this.bookOrder(obj)
        }
      } else {
        obj.psgList.forEach(item => {
          delete item.isCivil
        })
        this.bookOrder(obj)
      }
    },
    async bookOrder (obj) {
      let cache = null
      await this.$api['tkQuery/bookOrder'](obj).then(res => {
        cache = res.data || {}
      }).catch(res => {
        // this.$toast(res.tips)
      })
      let cacheOrder = cache.orderList[0] || []

      // 用户提交订单是否自动送审（1：是；0：否；）
      let p_20023 = false
      let { data = {} } = await this.$api['common/queryParameter']({ 'paramNos': '20023' })
      if (data && data.parameterResponses && data.parameterResponses[0] && data.parameterResponses[0].value1) {
        p_20023 = data.parameterResponses[0].value1 === '1'
      }

      //超标的后审订单进行送审提交以及审核
      if (obj.rangeList[0].reasonCode && this.tkSearchInfo.ccsqd.auditType === 1 || p_20023) {
        var params = {
          orderId: cacheOrder.orderId,
          orderType: '11001',
          orderNo: cacheOrder.orderNo
        }

        //审批规则
        let { data = [] } = await this.$api['approval/orderApproveList'](params)
        if (data.length > 0) {
          var currOrder = data[0]
          var spgz = currOrder.vipSpgzGetInfo
          var gznr = spgz.gznr[0]
          var spEmp = gznr.empList[0]
          //优先取有OAADMIN审批的员工信息
          for (let gz of spgz.gznr) {
            for (let emp of gz.empList) {
              if (emp.empNo == 'OAADMIN') {
                gznr = gz
                spEmp = emp
              }
            }
          }

          var sendAppParams = {
            orderId: cacheOrder.orderId,
            orderType: '11001',
            orderNo: cacheOrder.orderNo,
            spgzId: spgz.gzid,
            vipBpmPersonnels: [
              {
                empId: spEmp.empId,
                empName: spEmp.empName,
                gzid: spgz.gzid,
                jblx: spEmp.jblx || 0,
                spjb: gznr.level
              }
            ]
          }
          //送审
          await this.$api['approval/vipBpmSendAppNew'](sendAppParams)

          if (p_20023) {
            await this.$router.push({ path: '/allorder' })
          } else {
            //查询审批中订单
            let workItemId = ''
            await this.$api['approval/vipBpmForMyAppNew']({
              approveType: 1,
              count: 50
            }).then(res => {
              let approvingList = res.data.list[0].vipBpmForMyAppDtoList
              for (let approve of approvingList) {
                if (approve.orderId == cacheOrder.orderId) {
                  workItemId = approve.workItemId
                  break
                }
              }
            })
            if (workItemId) {
              //审批订单
              let receiveAppParams = {
                appRemark: '',
                completeState: 1,
                completeWay: 2,
                workItemId
              }
              await this.$api['approval/vipBpmReceiveAppResult'](receiveAppParams)
            }
          }
        }
      }
      this.jump(cache)
    },
    jump (cache) {
      if (cache.orderList.length > 1) {
        this.$dialog({
          confirmButtonText: '前往',
          message: '系统生成两个订单前往订单列表查看',
        }).then(() => {
          this.$router.push({
            path: '/allOrder?findType=1',
            query: {findType: 1, productType: '10901'}
          })
        })
      } else {
        this.$router.push({
          path: '/tk/tkCmplc',
          query: {
            orderId: cache.orderList[0].orderId, priceFlag: cache.priceFlag, msg: cache.msg, ertbx: this.ertbx,
            crbx: this.crbx,
          }
        })
      }
    },
    queryAgain(tips) {
      this.$dialog.confirm({
        title: this.$t('C474', '提示'),
        message: tips,
        confirmButtonText: this.$t('B061', '重新查询')
      }).then(() => {
        // on confirm
        let arriveAirport = this.tkSearchInfo.queryStr.arriveAirport
        let departAirport = this.tkSearchInfo.queryStr.departAirport
        this.tkSearchInfo.queryStr.arriveAirport = arriveAirport
        this.tkSearchInfo.queryStr.departAirport = departAirport
        this.tkSearchInfo.roundtrip = 0
        this.tkSearchInfo.flights = []
        this.tkSearchInfo.queryStr.departDate = this.tkSearchInfo.departDate.date
        this.$router.push({ path: '/tk/tkList', query: {} })
      }).catch(() => {
        // on cancel
      })
    },
    getLinker (info) {//修改联系人回调
      this.linker = {}
      this.linker = info
      if (info.linkEmail == '') {
        this.yc = false
      } else {
        this.yc = true
      }
    },
    toggle (ref, info) {
      if (info) {//退改规则参数
        this.changeRule = {
          'cacheId': info.cacheId,
          'flightNo': info.flightNo,
          'cabin': info.cabin.cabin,
          'priceId': info.price.priceId,
        }
      }
      this.$refs[ref].toggle()
    },
    getClbz() {
      if (this.pageCtrl.isShowCxr) {//判断是否需要获取差标
        this.$store.commit('SET_SERVICE', {cplx: '10901'})
        let clbz = this.pageCtrl.getClbzMinZj(this.travelerList)
        this.tkSearchInfo.minzj = clbz.minzj//最低差标等级
        this.tkSearchInfo.minzjName = clbz.minzjName//最低差标等级
        let str = {
          arriveAirport: this.tkSearchInfo.arrport.threeCode,
          departAirport: this.tkSearchInfo.depport.threeCode,
          empRank: this.tkSearchInfo.minzj,
          cplx: '10901'
        }
        if (!str.arriveAirport || !str.departAirport || !this.travelerList || this.travelerList.length < 1) {
          return
        }
        try {
          this.$api['tkQuery/GetClzbByMinZj'](str)
            .then(res => {
              let cache = res.data || {}
              if (cache.clbz) {
                if (this.tkSearchInfo.clbzTitle != cache.clbz) {
                  this.tkSearchInfo.clbzTitle = cache.clbz
                  this.matchClbz()
                }
              } else {
                this.tkSearchInfo.clbzTitle = ''
                this.tkSearchInfo.violate = {}
                this.tkSearchInfo.violateList = []
              }
            })
        } catch (error) {
          console.log(error)
        }
      }
    },
    // 获取是否违背
    matchClbz () {
      this.$api['tkQuery/matchClbz']({
        'cacheId': this.tkSearchInfo.flights[0].cacheId,
        'minZj': this.tkSearchInfo.minzj,
      }).then(res => {
        let cache = res.data || {}
        let priceId = this.tkSearchInfo.flights[0].price.priceId
        this.tkSearchInfo.violateList = cache
        if (cache[priceId]) {
          Object.assign(this.tkSearchInfo.violate, cache[priceId])
          this.$refs.travelinfo.getInfo({ ...this.tkSearchInfo.violate })
        } else {
          this.tkSearchInfo.violate = {}
          this.tkSearchInfo.violateList = []
        }
      })
    },
    checkBxList (val) {
      if (val && val.length > 1) {
        this.bxPrice = 0
        val.forEach((accumulator) => {
          this.bxPrice += accumulator.saleprice
        })
      } else if (val && val.length == 1) {
        this.bxPrice = val[0].saleprice
      } else {
        this.bxPrice = 0
      }
      this.initPrice()

    },
    checkRepeatPhone (psgList) {
      var o = {},
        isRepeat = false

      psgList.forEach(function (psg) {
        if (psg.psgType == 1) {
          if (o[psg.phoneNumber]) {
            isRepeat = true
          } else {
            o[psg.phoneNumber] = true
          }
        }
      })

      return isRepeat
    }
  },
  watch: {
    'travelerList.length'() {
      this.initPrice()
      this.getClbz()
    }
  }
}

</script>

<style lang="less" scoped>
@import '~Assets/styles/business';

.pad-r-8 {
  padding-right: 8px;
}

.pad-lr-16 {
  padding-left: 16px;
  padding-right: 16px;
}

.pad-b-20 {
  padding-bottom: 20px;
}

.borderRadius {
  border-radius: 4px;
}

.pad-b-20 {
  padding-bottom: 20px;
}

.agreementBox {
  margin: 0 0 12px 0;
  border-top: 1px solid #eee;
  line-height: 15px;
}

.ft-12 {
  font-size: 12px !important;
  width: 330px;
  position: relative;
  right: -25px;
}

.checkClass {
  width: 16px;
  top: 15px;
  position: relative;
  left: 5px;
}

.tkEdit {

  .box {
    padding: 0 6px;


    >div {
      margin-bottom: 5px;
    }

    .plane {
      height: 1.2rem;
    }
  }

  .FF {
    background: #fff;
    color: #000;
    height: 120px;
  }

  .tkEditwrapper {
    height: calc(100vh - 96px);
    overflow: hidden;
  }

  .text-indent {
    text-indent: 20px;
  }
}

.colorBlue {
  color: #0f7ffa;
}

.colorCustomized,
.colorCustomizedLight {
  color: #1863ed !important;
}

</style>
